import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchSchema = (params) => {
    return axios.get('/api/v1/customers/style_sheet/schema/', { params });
};

export const fetchPermissions = (params) => {
    return axios.get('/api/v1/customers/style_sheet/permissions/', { params });
};

export const fetchStylesheet = (params) => {
    return axios.get('/api/v1/customers/style_sheet/', { params });
};

export const createStyleRule = (data) => {
    return axios.post('/api/v1/customers/style_sheet/', data);
};

export const updateStyleRule = (id, data) => {
    return axios.patch(`/api/v1/customers/style_sheet/${id}/`, data);
};

export const deleteStylRule = (id) => {
    return axios.delete(`/api/v1/customers/style_sheet/${id}/`);
};
